import React from 'react';
import px2dp from '../../../../../utils/px2dp';

const height = typeof window !== 'undefined' && window.innerHeight;

const Empty = () => {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: height / 3,
                color: '#999',
                fontSize: px2dp(32),
                textAlign: 'center',
                boxSizing: 'border-box',
            }}
        >
            抱歉，没有找到相关商品
        </div>
    );
};

export default Empty;


// WEBPACK FOOTER //
// ./components/pipeline-goodsRecommend/lib/SHCard/widgets/Empty.js